import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import helpAndInformationViewStyles from 'src/views/pages/HelpAndInformation/HelpAndInformationView/helpAndInformationView.style';
import HelpSectionAccordion from './HelpSectionAccordion';

const HelpAndInformationView = forwardRef(({
  primaryCompany,
  textingProvider,
  classes,
}, ref) => (
  <div className={classes.root}>
    <HelpSectionAccordion
      ref={ref}
      primaryCompany={primaryCompany}
      textingProvider={textingProvider}
    />
  </div>
));

HelpAndInformationView.propTypes = {
  classes: PropTypes.object.isRequired,
  primaryCompany: PropTypes.string,
  textingProvider: PropTypes.string,
};

HelpAndInformationView.defaultProps = {
  primaryCompany: null,
  textingProvider: null,
};

export default withStyles(HelpAndInformationView, helpAndInformationViewStyles);
